import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon viewBox="0 0 100 100" {...props}>
      <title>{props.title || 'Looped'}</title>
      <g>
        <path d="M58.9 9.6l-1.8 11.1c14 2.3 24.8 14.4 24.8 29.1 0 16.3-13.2 29.5-29.5 29.5s-29.5-13.3-29.5-29.6c0-4.6 1-8.9 2.9-12.7l9.8 9.8 6.2-35.1-34.9 6.4 10.6 10.6c-3.7 6.1-5.8 13.3-5.8 21 0 22.5 18.2 40.7 40.7 40.7 22.5 0 40.7-18.2 40.7-40.7 0-20.2-14.8-37-34.2-40.1z" />
      </g>
    </Icon>
  )
}
